// BOT-1405: per-variant-option ingredient amount overrides.
//
// The option modal shows every product ingredient pre-filled with the
// product amount (or the saved override). Only rows whose amount differs
// from the product amount are persisted as override ingredient rows on the
// variant option; a row put back to the product amount, or cleared, drops
// its override.

export const normalizeIngredientName = name =>
  String(name ?? '')
    .replace(/\W/g, '')
    .toLowerCase()

const isBlank = value => value === '' || value === null || value === undefined

const rowFromIngredient = (ingredient, extra) => ({
  key: normalizeIngredientName(ingredient.attributes.name),
  name: ingredient.attributes.name,
  measurement: ingredient.attributes.measurement,
  ...extra
})

export const buildOverrideRows = (productIngredients, overrides) => {
  const rows = productIngredients.map(ingredient =>
    rowFromIngredient(ingredient, {
      baseAmount: ingredient.attributes.amount,
      amount: ingredient.attributes.amount,
      overrideId: null
    })
  )
  overrides.forEach(override => {
    const row = rows.find(candidate => candidate.key === normalizeIngredientName(override.attributes.name))
    if (row) {
      row.amount = override.attributes.amount
      row.measurement = override.attributes.measurement
      row.overrideId = override.id
    } else {
      rows.push(
        rowFromIngredient(override, { baseAmount: null, amount: override.attributes.amount, overrideId: override.id })
      )
    }
  })
  return rows
}

const matchesProductAmount = row => row.baseAmount !== null && Number(row.amount) === Number(row.baseAmount)

export const overrideAttributes = rows =>
  rows.flatMap(row => {
    if (isBlank(row.amount) || matchesProductAmount(row)) {
      return row.overrideId ? [{ id: row.overrideId, _destroy: true }] : []
    }
    return [{ id: row.overrideId, name: row.name, measurement: row.measurement, amount: Number(row.amount) }]
  })
